import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import router from './router'

const app = createApp(App);

app.use(router).mount('#app');

var links = [
    {
        href:'university',
        label:'University',
        color:"#003366",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'city',
        label:'City',
        color:"#999966",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'industry',
        label:'Industry',
        color:"#bf5b17",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'energy',
        label:'Energy',
        color:"#339966",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'transport',
        label:'Transport',
        color:"#ff9900",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'action',
        label:'Action',
        color:"#666699",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    },
    {
        href:'gentrification',
        label:'Gentrification',
        color:"#29a3a3",
        nodes:[
            {
                href:'intro',
                label:'Intro'
            },
            {
                href:'interdependencies',
                label:'Interdependencies'
            },
            {
                href:'inequalities',
                label:'Inequalities'
            },
            {
                href:'alternatives',
                label:'Alternatives'
            }]
    }]


app.provide('links', links)

